/**
 * @desc 获取销售计划详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 销售计划ID */
  salePlanId: string;
  /** 地销计划2统销计划3粉磨站计划4 */
  salePlanType?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleDetailResponse>>> {
  return defHttp.get({
    url: '/web/plan/searchDetail',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleDetailResponse>>> {
  return defHttp.get({
    url: '/mock/web/plan/searchDetail',

    params,
  });
}
